import React from 'react'
import PropTypes from 'prop-types'
import {Text, Box} from '@chakra-ui/react'

export const TextTitle = ({
    alignment = 'left',
    as = 'p',
    textStyle = 'body-medium',
    color = 'foreground.neutral.muted',
    fontWeight = 'normal',
    fontFamily = 'heading',

    ...props
}) => {
    return (
        <Box {...props}>
            <Text
                as={as}
                textAlign={alignment}
                textStyle={textStyle}
                fontWeight={fontWeight}
                color={color}
                fontFamily={fontFamily}
            >
                {props.children}
            </Text>
        </Box>
    )
}

TextTitle.propTypes = {
    as: PropTypes.string,
    alignment: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    textStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    color: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    fontFamily: PropTypes.string,
}
